import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/autoplay';
import { Autoplay } from 'swiper/modules';
import { CheckCircle2 } from 'lucide-react';

export default function About({ darkMode }) {
  const skills = [
    { label: 'Risk Management', value: 99.6 },
    { label: 'Financial Protection', value: 99.3 },
    { label: 'Tax-saving Investment Strategies', value: 99.1 },
    { label: 'Life Insurance Consulting', value: 99.9 },
  ];

  const softSkills = [
    'Financial Goal Mapping',
    'Personalized Financial Planning',
    'Trust-building & Ethical Advisory',
    'Excellent Communication & Negotiation',
    'Long-term Client Relationship Management',
  ];

  // const partners = ['Max Life Insurance', 'HDFC Life', 'Bajaj Allianz'];

  return (
    <section id="about" className={`py-24 transition-colors duration-300
      ${darkMode ? 'bg-[#080D1A]' : 'bg-[#F0EDE6]'}`}>
      <div className="container mx-auto px-4 lg:px-16">

        {/* Section Header */}
        <div className="mb-16 text-center">
          <p className={`text-xs font-medium tracking-[0.3em] uppercase mb-3
            ${darkMode ? 'text-[#C9A84C]/70' : 'text-[#8B6914]'}`}>
            Who I Am
          </p>
          <h2 className={`text-4xl lg:text-5xl font-bold ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
            About <span className="text-[#C9A84C]">Me</span>
          </h2>
          <div className="w-16 h-0.5 bg-[#C9A84C] mx-auto mt-5"></div>
        </div>

        <div className="max-w-5xl mx-auto">

          {/* Bio Card */}
          <div className={`rounded-2xl p-8 lg:p-10 mb-10 border relative overflow-hidden
            ${darkMode
              ? 'bg-[#0D1525] border-[#C9A84C]/10'
              : 'bg-white border-[#C9A84C]/20'
            }`}>
            {/* Decorative corner */}
            <div className="absolute top-0 right-0 w-32 h-32 opacity-5"
              style={{ background: 'radial-gradient(circle at top right, #C9A84C, transparent)' }}></div>

            {/* Partner logos row
            <div className="flex flex-wrap gap-3 mb-8">
              {partners.map((p, i) => (
                <span key={i} className={`px-3 py-1.5 text-xs font-medium rounded-lg border
                  ${darkMode
                    ? 'border-[#C9A84C]/20 text-[#C9A84C]/70 bg-[#C9A84C]/5'
                    : 'border-[#C9A84C]/30 text-[#8B6914] bg-[#C9A84C]/10'
                  }`}>
                  {p}
                </span>
              ))}
            </div> */}

            <p className={`text-base lg:text-lg leading-relaxed mb-5
              ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              I am Manoj Pant, a dedicated Financial Advisor and Consultant with over 10 years of experience in the financial services industry. Throughout my journey, I have had the privilege of working with leading organizations such as Max Life Insurance, HDFC Life, Bajaj Allianz, and Canara HSBC, helping individuals and families build a secure financial future.

              But today, my purpose goes beyond providing financial advice.

              I am on a mission to help the first 10,000 families in India become financially secure.
            </p>
            <p className={`text-base lg:text-lg leading-relaxed mb-5
              ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              I am on a mission to help the first 10,000 families in India become financially secure.

              I firmly believe that true financial freedom is not determined by how much a family earns—it is built through the right financial planning, informed decisions, and long-term discipline. Every family deserves protection, peace of mind, and the confidence to face the future without financial fear.
            </p>
            <p className={`text-base lg:text-lg leading-relaxed
              ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              My expertise includes:

              Life Insurance Planning,
              Term Insurance,
              Retirement Planning,
              Child Education Planning,
              Savings & Investment Strategies,
              Wealth Creation & Preservation,
              Long-Term Financial Planning,

              Every recommendation I make is based on trust, transparency, integrity, and the unique goals of each family. My focus is never on selling products—it is on helping people make informed financial decisions that create lasting security and prosperity.

              Over the years, I have guided hundreds of individuals and families toward stronger financial futures. Now, through this mission, I aim to reach thousands more by spreading financial awareness, simplifying complex financial concepts, and inspiring people to take action.

              If you believe that every family deserves financial security and want to be part of a movement that creates a stronger and more prosperous India, I warmly invite you to join me.

              Mission 10,000 Families is not just my mission.

              It's our mission.

              Every Family Secure. A Prosperous India.
              </p>
          </div>

          {/* Image Carousel */}
      <div className="flex justify-center mb-10">
  <div
  className={`w-full max-w-5xl rounded-2xl overflow-hidden border ${
    darkMode ? 'border-[#C9A84C]/10' : 'border-[#C9A84C]/20'
  }`}
>

    <Swiper
      modules={[Autoplay]}
      autoplay={{ delay: 2500, disableOnInteraction: false }}
      loop={true}
      spaceBetween={0}
      slidesPerView={1}
    >
      {['clients2', 'clients3'].map((img, i) => (
  <SwiperSlide key={i}>
    <img
      src={'/images/' + img + '.jpeg'}
      alt={`Clients ${i + 1}`}
      className="w-full h-80 md:h-[420px] lg:h-[550px] object-cover"
    />
  </SwiperSlide>
))}
    </Swiper>

  </div>
</div>

          {/* Skills Grid */}
          <div className="grid md:grid-cols-2 gap-6">

            {/* Skill Bars */}
            <div className={`p-8 rounded-2xl border
              ${darkMode ? 'bg-[#0D1525] border-[#C9A84C]/10' : 'bg-white border-[#C9A84C]/20'}`}>
              <h3 className={`text-lg font-semibold mb-7 flex items-center gap-2
                ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
                <span className="w-1 h-5 bg-[#C9A84C] rounded-full inline-block"></span>
                Skills & Expertise
              </h3>
              <div className="space-y-5">
                {skills.map((skill, i) => (
                  <div key={i}>
                    <div className="flex justify-between mb-2">
                      <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>{skill.label}</span>
                      <span className="text-sm font-semibold text-[#C9A84C]">{skill.value}%</span>
                    </div>
                    <div className={`h-1.5 rounded-full ${darkMode ? 'bg-[#C9A84C]/10' : 'bg-[#C9A84C]/15'}`}>
                      <div
                        className="h-1.5 rounded-full bg-[#C9A84C] transition-all duration-1000"
                        style={{ width: `${skill.value}%` }}
                      ></div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Soft Skills */}
            <div className={`p-8 rounded-2xl border
              ${darkMode ? 'bg-[#0D1525] border-[#C9A84C]/10' : 'bg-white border-[#C9A84C]/20'}`}>
              <h3 className={`text-lg font-semibold mb-7 flex items-center gap-2
                ${darkMode ? 'text-white' : 'text-[#0A0F1E]'}`}>
                <span className="w-1 h-5 bg-[#C9A84C] rounded-full inline-block"></span>
                Client Handling & Advisory
              </h3>
              <div className="space-y-3">
                {softSkills.map((skill, i) => (
                  <div key={i} className="flex items-start gap-3">
                    <CheckCircle2 size={16} className="text-[#C9A84C] mt-0.5 flex-shrink-0" />
                    <span className={`text-sm leading-relaxed ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>{skill}</span>
                  </div>
                ))}
              </div>
            </div>

          </div>
        </div>
      </div>
    </section>
  );
}